export default {
  'sidebar.compras': 'Purchases',
};
